import { render, staticRenderFns } from "./AfterSales.vue?vue&type=template&id=7bbbdf09&scoped=true&"
import script from "./AfterSales.vue?vue&type=script&lang=js&"
export * from "./AfterSales.vue?vue&type=script&lang=js&"
import style0 from "./AfterSales.vue?vue&type=style&index=0&id=7bbbdf09&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbbdf09",
  null
  
)

export default component.exports